import { AppRouteUi } from "./appRoute";
import {
  SvgAppointments,
  SvgDashboard,
  SvgInvoice,
  SvgSettings,
  SvgTaskList,
} from "../assets/svg";
import React from "react";
import {
  SvgPatientList,
  SvgCaregiverList,
  SvgFinance,
} from "../assets/svg/index";

export const NavConfig: {
  [key: string]: {
    path: string;
    icon?: React.FunctionComponent<
      React.SVGProps<SVGSVGElement> & {
        title?: string | undefined;
      }
    >;
    activeOnPaths?: string[];
  };
} = {
  settings: {
    path: AppRouteUi.Settings.Root(),
    icon: SvgSettings,
  },
  dashboard: {
    path: AppRouteUi.Dashboard.Root(),
    icon: SvgDashboard,
  },
  company: {
    path: AppRouteUi.Company.Root(),
  },
  users: {
    path: AppRouteUi.Users.Root(),
  },
  "admin-panel": {
    path: "#",
    icon: SvgAppointments,
    activeOnPaths: [AppRouteUi.Company.Root(), AppRouteUi.Users.Root()],
  },
  patient: {
    path: AppRouteUi.Patient.Root(),
    icon: SvgPatientList,
  },
  caregiver: {
    path: AppRouteUi.Caregiver.Root(),
    icon: SvgCaregiverList,
  },
  appointment: {
    path: AppRouteUi.Appointment.Root(),
    icon: SvgAppointments,
  },
  "task-list": {
    path: AppRouteUi.ManageTaskList.Root(),
    icon: SvgTaskList,
  },
  finance: {
    path: "#",
    icon: SvgFinance,
    activeOnPaths: [
      AppRouteUi.Finance.Patient(),
      AppRouteUi.Finance.Caregiver(),
    ],
  },
  financePatient: {
    path: AppRouteUi.Finance.Patient(),
  },
  financeCaregiver: {
    path: AppRouteUi.Finance.Caregiver(),
  },
  invoice: {
    path: AppRouteUi.Invoice.Root(),
    icon: SvgInvoice,
  },
  insurance: {
    path: AppRouteUi.Insurance.Root(),
    icon: SvgTaskList,
  },
  report: {
    path: AppRouteUi.Report.Root(),
    icon: SvgInvoice,
  },
  import: {
    path: AppRouteUi.Import.Root(),
    icon: SvgInvoice,
  },
  billing: {
    path: "#",
    icon: SvgFinance,
    activeOnPaths: [
      AppRouteUi.Billing.PaymentMethod(),
      AppRouteUi.Billing.Invoice(),
    ],
  },
  paymentMethod: {
    path: AppRouteUi.Billing.PaymentMethod(),
    icon: SvgFinance,
  },
  billingInvoice: {
    path: AppRouteUi.Billing.Invoice(),
    icon: SvgFinance,
  },
  dataExchange: {
    path: AppRouteUi.DataExchange.Root(),
    icon: SvgFinance,
  },
  hhaConfig: {
    path: AppRouteUi.HHAConfig.Root(),
    icon: SvgFinance,
  },
};
